module.exports = __webpack_public_path__ + "img/casino.c9078a90.jpg";